// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import Formatter from '../../i18n/formatter';
import theme from '../../styled-components/dark';

const PreviousOddRow = styled.div`
  text-align: right;
  width: 100%;
`;

const PreviousOdd = styled.div`
  display: inline-block;
  color: ${theme.BasketFooter.previousOddColor};
  font-weight: bold;
  text-decoration: line-through;
`;

type BasketCardPreviousOddProps = {
  previousOdd: number;
};

const BasketCardPreviousOdd = ({ previousOdd }: BasketCardPreviousOddProps) => {
  return (
    <PreviousOddRow>
      <PreviousOdd>{Formatter.formatOdd(previousOdd)}</PreviousOdd>
    </PreviousOddRow>
  );
};

export default React.memo<BasketCardPreviousOddProps>(BasketCardPreviousOdd);
